import { createTheme } from '@mui/material'

export const spacingItem = { marginTop: 2 }
export const spacingItemEquivalentForMask = { marginTop: 1 }

export const blue = 'rgba(32, 56, 100, 1)'
export const red = '#BC8076'
export const blueSky = '#698DAC'
export const lightGrey = '#F0F0F0'
export const yellowSemiLight = '#FFC300'
export const titleGrey = '#7C7C7C'

export const colors = {
  cello: '#203864',
  black: '#000000',
  white: '#FFFFFF',
  azalea: '#F7C8DF',
  mintTulip: '#D2E9F7',
  anakiwa: '#82CFFF',
  silver: '#CCCCCC',
  amber: '#FFC300',
  seaGreen: '#2F7D32',
  lightGreen: '#A8D5BA',
  athensGray: '#EEEFF3',
  punch: '#D93025',
  peach: '#FFE7AD',
  bermudaGray: '#698DAC',
  geyser: '#D6DEE1',
  yellowSemiLight,
  lightGrey,
  blueSky,
  red,
  blue,
}

export const theme = createTheme({
  palette: {
    primary: {
      main: '#FCB402',
      contrastText: '#fff', //button text white instead of black
      light: '#FFF8E2',
    },
    secondary: {
      main: '#698DAC',
      contrastText: '#fff',
    },
    warning: { main: '#F9A825' },
  },
  typography: {
    fontFamily: 'Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif;',
    fontSize: 14,
    subtitle1: { fontSize: 19, fontWeight: 800, lineHeight: 1.2, color: blue },
    subtitle2: { fontSize: 12, fontWeight: 800, lineHeight: 1.2 },
    body1: { fontSize: 16, lineHeight: 1.35 },
    body2: { fontSize: 14, lineHeight: 1.35 },
    caption: { fontSize: 12, lineHeight: 1.3, fontWeight: 700 },
    h4: { color: blue },
    h5: {
      fontSize: '1.2rem',
    },
    h6: {
      fontSize: '0.9rem',
    },
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          backgroundColor: 'rgba(255, 255, 255, 0.92)',
          transition: 'box-shadow 140ms ease, border-color 140ms ease, background-color 140ms ease',
          '&:not(.MuiInputBase-multiline)': {
            alignItems: 'center',
          },
        },
        input: {
          lineHeight: 1.35,
          fontSize: 14,
          fontWeight: 400,
          '&::placeholder': {
            fontSize: 11.5,
            fontWeight: 300,
            lineHeight: 1.35,
            color: '#9AA3B5',
            opacity: 1,
          },
        },
        notchedOutline: {
          borderColor: 'rgba(122, 129, 151, 0.24)',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: 13,
          fontWeight: 400,
          color: '#7A8197',
        },
        shrink: {
          fontSize: 12,
          fontWeight: 400,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          '&::placeholder': {
            fontSize: 11.5,
            fontWeight: 300,
            lineHeight: 1.35,
            color: '#9AA3B5',
            opacity: 1,
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: 0,
          marginRight: 0,
          fontSize: 11.5,
          fontWeight: 500,
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          borderRadius: 12,
          border: '1px solid rgba(228, 232, 242, 0.9)',
          boxShadow: '0 8px 24px rgba(32, 56, 100, 0.12)',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          fontWeight: 500,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(255, 255, 255, 0.78)',
          border: '1px solid #E4E8F2',
          borderRadius: 16,
          boxShadow: '0 1px 2px rgba(32, 56, 100, 0.04)',
          overflow: 'hidden',
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          color: '#db3131',
          '&$error': {
            color: '#db3131',
          },
        },
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        // Name of the slot
        title: {
          // Some CSS
          fontWeight: 'bold',
          color: blue,
        },
      },
    },
  },
})
